import React from 'react'
import {Link} from 'react-router-dom';

import './item.scss'
import '../../../css/fonts/fonts.scss'
/*
* Function element for photo container.
* July 28st, 2022
*/
export function ItemContainer({ tema, exTema, links_Up, links_Down }) {
    return (
        <>
            {tema &&
            <div className="ic-photo__titles" style={{backgroundColor: `${tema.titleBgColor}`}}>
                <h1 className="ic-title__principal">{tema.name}</h1>
                <h1 className="ic-title__lower">{tema.lower_title}</h1>
            </div>}
            <div className="ic-themes__links" >
                <div className="links__ctn">
                <div className='ic-links__articles'>
                    {links_Up.map( (elt, index) => (
                            <Link to={elt.collegamento} key={index}><p className="link__summary">{elt.titolo}</p></Link>
                        ))};
                    </div> 
                    <div className='ic-theme__argument'>
                        {exTema && <h3>{exTema.name}</h3>}
                    </div>
                    <div className='ic-links__articles'>
                        {links_Down.map( (elt, index) => (
                            <Link to={elt.collegamento} key={index} state={{index: elt.id_accord ? elt.id_accord : null}}><p className="link__summary">{elt.titolo}</p></Link>
                        ))};
                    </div>
                </div> 
            </div>
        </>
    )
}

/*
* Function element for items grid cell.
* July 28st, 2022
*/
export function ItemCell({item}) {
    return (
        <>
            {item.map(elt  => (
                <div className="grid__item" key={elt.id_article}>
                    <h1 className="title__card">{elt.articolo_titolo}</h1>
                    <img className='article__img' src={require(`../../../components/images/${elt.pic}`)} alt='cell-pics' />
                    <p className="summary__paraph">{elt.descrizione}</p>
                    <Link to={elt.collegamento}><button className="btn__card"><span>{elt.nav_tab}</span></button></Link>
                </div>
            )) }
        </>
    )
}

/*
* Function element for items grid cell.
* July 28st, 2022
*/
export function ItemAccord({item}) {
    return (
        <>
            {item.map(elt  => (
                <div className="grid__item" key={elt.id_accord}>
                    <h1 className="title__card">{elt.sotto_titolo}</h1>
                    <img className='article__stemma' src={require(`../../../components/images/${elt.pic}`)} alt='cell-pics' />
                    <p className="summary__paraph">{elt.cronaca}</p>
                    <Link to={elt.vincolo} state={{index: elt.id_accord}}><button className="btn__card"><span>{elt.name} </span></button></Link>
                </div>
            )) }
        </>
    )
}

/*
* Function element for items pub grid cell.
* July 28st, 2022
*/
export function ItemCellPub({picturePub, linkPage, tleUp, tleDown, temi}) {
    return (
        <div className="grid__item--pub">
            <div className="pub__titles">
                <p className="pub__title">{tleUp}</p>
                <p className="pub__title">{tleDown}</p>
            </div>
            <div className="item__pub">
            <img src={picturePub} alt="" />
            </div>
            <Link to={linkPage} state={{ temi }}><button className="btn__card"><span>Avanti </span></button></Link>
        </div> 
    )
}



